import { useState, useEffect ,useRef} from "react";
import { Typography, Box, IconButton, Button, Table, Grid,TableBody, TableCell,Divider, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useReactToPrint } from "react-to-print";
import { useAuth } from "../../../../AuthProvider";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const ProgressCard = () => {
  const navigate = useNavigate();
  const {oId,board,pId}=useAuth();
  const location = useLocation();
  const componentRef = useRef();
  const studentProgress = JSON.parse(sessionStorage.getItem("studentProgress"));
 const [studentInfo, setStudentInfo] = useState({});
const [subjectMarks, setSubjectMarks] = useState([]);

   const [companyInfo, setCompanyInfo] = useState({
          schoolName: "",
          pincode: "",
          primaryContact: "",
          secondaryContact: "",
          boardAffiliation: "",
          schoolAddress: "",
          affiliationNumber: "",
          city: "",
          state: "",
          schoolEmailId: "",
          schoolLogo: "",
          schoolStamp: "",
        });

  const fetchData = async () => {
   
    if (!studentProgress?.studentId || !studentProgress?.type) {
  console.warn("Missing studentId or type, API will not be called");
  return;
}
    try {
      const response = await fetch(
        `${baseUrl}/api/markSheet/getReportCardOverallMarks/${oId}/${pId}/${studentProgress.studentId}?type=${studentProgress.type}`
      );
      const data = await response.json();

      if (data) {
        const { subjectMarks, ...rest } = data;
        setStudentInfo(rest);
        setSubjectMarks(subjectMarks || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
  fetchData();
}, []);
 //organization details api 
          useEffect(() => {
            const fetchCompanyInfo = async () => {
              try {
                const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                setCompanyInfo({
                  schoolLogo: data.schoolLogo,
                  schoolStamp:data.schoolStamp,
                  schoolName: data.schoolName,
                  city: data.city,
                  state: data.state,
                  affiliationNumber: data.affiliationNumber,
                  schoolAddress: data.schoolAddress,
                  primaryContact: data.primaryContact,
                  boardAffiliation: data.boardAffiliation,
                  secondaryContact: data.secondaryContact,
                  pincode: data.pincode,
                  schoolEmailId: data.schoolEmailId,
                });
              } catch (error) {
                console.error("Error fetching company info:", error);
               
              }
            };
        
            fetchCompanyInfo();
          }, []);

const formatExamType = (type) => {
  if (!type) return "";

  const parts = type.trim().toUpperCase().split("-");

  if (parts.length !== 2) return type;

  const [prefix, number] = parts;

  switch (prefix) {
    case "FA":
      return `Formative Assessment - ${number}`;
    case "SA":
      return `Summative Assessment - ${number}`;
    default:
      return type;
  }
};
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "",
    pageStyle: `
      @page {
        margin-top: 50px; /* Adjust this value for desired spacing */
      }
      body {
        margin-top: 50px; /* Ensures it works on different browsers */
      }
    `,
  });
  
  return (
    <Box
      sx={{
        backgroundColor: "#f9fafb",
        padding: "2rem",
        borderRadius: "1rem",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        width: "97%",
        // height: "100vh",
        margin: "5% 20px 20px 20px",
        border: "1px solid #D1D5DB",
      }}
    >
      <Box sx={{ marginBottom: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography variant="h4" component="h3" sx={{ fontWeight: "bold", marginLeft: 1 }}>
            Student Report Card
          </Typography>
        </Box>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#3C3972",
            color: "white",
            "&:hover": {
              backgroundColor: "#3C3972",
            },
          }}
          onClick={handlePrint}
        >
          Print
        </Button>
      </Box>

      {/* {studentData ? ( */}
        <Box
          // id="report-card"
          ref={componentRef}
          sx={{
            backgroundColor: "#FEF3C7",
            padding: "0rem 1.5rem 1.5rem 1.5rem",
            borderRadius: "0.75rem",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
            border: "2px solid #D97706",
            width: "600px",
            margin: "auto",
            // marginTop: "50px 20px 20px 20px",
          }}
        >

          <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box width="20%" marginTop="10px">
                      <img
                        src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                        alt="Logo"
                        style={{
                          width: "80px",         // Set a single value
                          height: "80px",        // Match the width exactly
                          borderRadius: "50%",    // Ensures circle
                          objectFit: "cover",     // Ensures image fills without distortion
                        }}
                      />
          
                    </Box>
                    <Box textAlign="center" flexGrow={1}>
                       <Grid item xs={12} sm={8}>
                                                      <Grid container direction="column" spacing={1}>
                                                        <Grid item>
                                                          <Typography variant="h4" style={{ fontWeight: "bold", color: "red" }}>
                                                            {companyInfo.schoolName}
                                                          </Typography>
                                                        </Grid>

                                                        <Grid item>
                                                          <Typography variant="h5" style={{ fontWeight: "bold", }}>
                                                          {formatExamType(studentInfo?.type)}
                                                          </Typography>
                                                        </Grid>
                                                                        
                      
                                                      </Grid>
                                                    </Grid> 
                    </Box>
                    <Box width="20%" />
          </Box>
 <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            STUDENT REPORT CARD
          </Typography>
          <Divider sx={{ my: 1, borderBottomWidth: '1px', borderColor: 'black' }} />
          {/* Student Info */}
          <Box sx={{ marginBottom: "1rem", padding: "1rem", borderRadius: "5px", backgroundColor: "#fff5db" , }}>
              <Grid container spacing={2}>
              <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Student Name:</strong> {studentProgress?.firstName} {studentProgress?.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Roll No:</strong> {studentInfo?.studentRollNumber}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>{board === "INTERMEDIATE" ? "Year:" : "Class:"}</strong> {studentInfo?.romanNumberClass}
                  </Typography>
                </Grid>
              {(board === "INTERMEDIATE") &&(
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Course:</strong> {studentInfo?.course}
                  </Typography>
                </Grid>
              )}
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Section:</strong> {studentInfo?.sections}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Total Marks:</strong> {studentInfo?.totalMarks}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Obtained Marks:</strong> {studentInfo?.obtainedMarks ? studentInfo?.obtainedMarks.toFixed(2) : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Overall Grade:</strong> {studentInfo?.overallGrade}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          {/* Subjects Table */}
          <TableContainer component={Paper} sx={{ backgroundColor: "#fff5db" }}>
            <Table>
              <TableHead sx={{ backgroundColor: "#3C3972" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold",textAlign:"center"  }}>Sl.No</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold",textAlign:"center"  }}>Subject</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold",textAlign:"center"  }}>Total Marks</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold" ,textAlign:"center" }}>Obtained Marks</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold",textAlign:"center"  }}>Grade</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subjectMarks.map((row,index) => (
                  <TableRow key={row.subjectId}>
                    <TableCell sx={{ fontWeight: "bold",textAlign:"center"  }}>{index+1}</TableCell>
                    <TableCell sx={{ textAlign:"center" }}>{row.subject}</TableCell>
                    <TableCell sx={{ textAlign:"center" }}>{row.subjectTotalMarks}</TableCell>
                    <TableCell sx={{ textAlign:"center" }}>{row.marks}</TableCell>
                    <TableCell sx={{ textAlign:"center" }}>{row.grade}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Signature Fields */}
          <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "2rem", padding: "1rem" }}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="body1" sx={{ borderTop: "1px solid black", width: "150px", margin: "auto" }}>
                Teacher Signature
              </Typography>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="body1" sx={{ borderTop: "1px solid black", width: "150px", margin: "auto" }}>
                Parent Signature
              </Typography>
            </Box>
          </Box>
        </Box>
    </Box>
  );
};

export default ProgressCard;